import { ComponentProps, ReactNode } from 'react'
import { Check } from 'lucide-react'

type PropsControl = Omit<ComponentProps<'input'>, 'type'> & {
  /** Texto de la opción. Con `etiquetaOculta` se lee solo con lector de pantalla (p. ej. en una fila de tabla). */
  etiqueta: ReactNode
  etiquetaOculta?: boolean
}

/** Casilla del kit (`dcc-control` + `dcc-box`). */
export function Casilla({ etiqueta, etiquetaOculta = false, className, ...props }: PropsControl) {
  return (
    <label className={`dcc-control${className ? ` ${className}` : ''}`}>
      <input type="checkbox" {...props} />
      <span className="dcc-box" aria-hidden>
        <Check className="dcc-check" />
      </span>
      <span className={etiquetaOculta ? 'visualmente-oculto' : undefined}>{etiqueta}</span>
    </label>
  )
}

/** Interruptor del kit (`dcc-control` + `dcc-track`): un sí/no que se aplica al tiro. */
export function Interruptor({ etiqueta, etiquetaOculta = false, className, ...props }: PropsControl) {
  return (
    <label className={`dcc-control${className ? ` ${className}` : ''}`}>
      <input type="checkbox" role="switch" {...props} />
      <span className="dcc-track" aria-hidden />
      <span className={etiquetaOculta ? 'visualmente-oculto' : undefined}>{etiqueta}</span>
    </label>
  )
}
